<template>
    <tailwind-layout title="RocketLawyer Templates">
        <div class="space-y-6">
            <BridgeBackLink />
            <header>
                <h1 class="text-2xl font-bold tracking-tight text-rent-risk-blue-400">RocketLawyer Templates</h1>
                <p class="mt-1 text-sm text-gray-600">
                    The document templates we have access to from RocketLawyer, stored locally so the lease wizard
                    resolves them without querying RL at runtime. Read-only — {{ total }} templates.
                </p>
            </header>

            <!-- Per-category counts -->
            <div class="grid grid-cols-1 gap-4 sm:grid-cols-3">
                <div
                    v-for="group in groups"
                    :key="`tile-${group.category}`"
                    class="rounded-xl border border-gray-200 bg-white p-4 shadow-sm"
                >
                    <p class="text-xs font-semibold uppercase tracking-wider text-gray-400">{{ group.label }}</p>
                    <p class="mt-1 text-2xl font-bold text-gray-900">{{ group.count }}</p>
                </div>
            </div>

            <!-- One table per category -->
            <section v-for="group in groups" :key="group.category" class="space-y-2">
                <div>
                    <h2 class="text-lg font-semibold text-gray-900">{{ group.label }}</h2>
                    <p class="text-sm text-gray-500">{{ group.description }}</p>
                </div>

                <div class="overflow-hidden rounded-md shadow lg:border">
                    <table class="min-w-full divide-y divide-gray-300">
                        <thead class="bg-blue-50">
                            <tr>
                                <th scope="col" class="px-6 py-3 text-left text-xs font-bold uppercase tracking-wider">Name</th>
                                <th scope="col" class="px-6 py-3 text-left text-xs font-bold uppercase tracking-wider">Template ID</th>
                            </tr>
                        </thead>
                        <tbody class="divide-y divide-gray-200">
                            <tr v-for="template in group.templates" :key="template.template_id + template.name" class="bg-white hover:bg-gray-100">
                                <td class="px-6 py-3 text-sm font-medium text-gray-900">{{ template.name }}</td>
                                <td class="px-6 py-3 font-mono text-xs text-gray-500">{{ template.template_id }}</td>
                            </tr>
                            <tr v-show="!group.templates.length">
                                <td colspan="2" class="px-6 py-4 text-center text-sm font-medium text-gray-400">
                                    No templates in this category.
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </section>
        </div>
    </tailwind-layout>
</template>

<script setup>
import TailwindLayout from '@/Layouts/TailwindLayout.vue'
import BridgeBackLink from '@/Shared/BridgeBackLink.vue'

defineProps({
    groups: Array,
    total: Number,
})
</script>
